/// <amd-module name="VSSUI/Components/ZeroData/index" />
export * from "./ZeroData";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { ZeroDataActionType, IZeroDataItem, IZeroDataProps, IZeroDataMultipleProps } from "./ZeroData.Props";
